import type { FaireProductEntity } from "../../entity_types/product";

export const p_r5afre3vpd: FaireProductEntity = {
  token: "p_r5afre3vpd",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE PINK",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/4107690f272d46f11c9a745e32f60502ae1b3e28e6926f2b23efe4a9591fa43f.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:07.693Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
